import { DataBean } from "../DataBean";

export class UpdateBankingConciliation extends DataBean {


    public async updateBankingConciliationBookLeft(idBankingConciliation:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.documents.BankingConciliation_updateBankingConciliationBookLeft_Number", [idBankingConciliation]);
    }

        public async applyBankingStatementToBankingConciliation(idBankingConciliation:any,idBankingStatement:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.documents.BankingConciliation_applyBankingStatementToBankingConciliation_Number_Number", [idBankingConciliation,idBankingStatement]);
    }

}